import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
// import instance from "../myconfig";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    stepper: false,
    stepperNow: "welcome",
    page: "register",
    masterData: [],
    user: {},
    loading: false,
  },
  getters: {},
  mutations: {
    SET_MASTER_DATA(state, payload) {
      state.masterData = payload;
    },
    SET_LOADING(state) {
      state.loading = true;
    },
    SET_FINISH_LOADING(state) {
      state.loading = false;
    },
    SET_USER_DATA(state, payload) {
      state.user = payload;
    },
  },
  actions: {
    registerLpse({ commit }, payload) {
      const registerLpseUrl = process.env.VUE_APP_BASE_URL + "lpse";
      commit("SET_LOADING");
      return axios
        .post(registerLpseUrl, payload)
        .then((r) => {
          commit("SET_FINISH_LOADING");
          return r;
        })
        .catch((error) => {
          commit("SET_FINISH_LOADING");
          return error;
        });
    },
    getJobType({ commit }) {
      const getJobTypeUrl = process.env.VUE_APP_THIRD_URL + "job-type";
      commit("SET_LOADING");
      return axios
        .get(getJobTypeUrl)
        .then((r) => {
          commit("SET_FINISH_LOADING");
          return r;
        })
        .catch((error) => {
          commit("SET_FINISH_LOADING");
          return error;
        });
    },
  },
  modules: {},
});
